import React, { useEffect, memo, useState, useCallback, useRef } from 'react';
import './index.less';
import { LeftOutlined } from '@ant-design/icons';
import ExamPointDeFinition from '@/pages/exam-point-detail/components/exam-point-definition';
import ExamPointPractice from '@/pages/exam-point-detail/components/exam-point-practice';
import ExamPointAnalysis from '@/pages/exam-point-detail/components/exam-point-analysis';
import ExamPointVideos from '@/pages/exam-point-detail/components/exam-point-videos';
import AiSuggestion from '@/pages/exam-point-detail/components/ai-suggestion';
import AiEfficiency from '@/pages/exam-point-detail/components/ai-efficiency';
import ExamPointChart from '@/pages/exam-point-detail/components/exam-point-chart';
import globalStore from '@/store/global';
import { getPredictScoreExamPointDetail } from '@/apis';
import { IPredictionScoreExamPointDetail } from '@/types';
import { areKeysPresentAndNonEmpty } from '@/utils';

export interface IInitInfo {
    projectId: number; // 项目id
    subjectId: number; // 科目id
    examSeasonId: number; // 考季id
    knowledgeId: number; // 考点ID
    sourceFromType: number;
    hasAllRequiredParams: boolean;
    knowledgeSource: number; // 考点来源 默认 0：预测分 1 解析页考点标签
    businessParam?: { [key: string]: any };
}

const ExamPointDetail = () => {
    const detailDataInitInfo = useRef({
        knowledgeId: 0,
        title: '',
        important: 0,
        importantDesc: '',
        definition: '',
        learnStatus: 0,
        paperDataLogId: 0,
        totalQuestionCount: 0,
        finishedQuestionCount: 0,
        goalScore: 0,
        totalScore: 0,
        predictionScore: 0,
        submitStatus: 0,
        showPopup: 0,
        efficiency: '',
        efficiencyDesc: '',
        efficiencyNotice: '',
    });
    const [initInfo, setInitInfo] = useState<IInitInfo>();
    const [detailData, setDetailData] = useState<IPredictionScoreExamPointDetail>(detailDataInitInfo.current);

    const fetchDetailData = useCallback(async () => {
        const { projectId, subjectId, examSeasonId, knowledgeId, knowledgeSource } = initInfo!;
        const response = await getPredictScoreExamPointDetail({
            projectId,
            subjectId,
            examSeasonId,
            knowledgeId,
            knowledgeSource,
        });
        if (response.status === 0 && response.result) {
            setDetailData(response.result);
        }
    }, [initInfo]);

    useEffect(() => {
        if (initInfo?.knowledgeId && initInfo?.hasAllRequiredParams) {
            fetchDetailData();
        }
    }, [initInfo?.knowledgeId]);

    useEffect(() => {
        globalStore.subscribe('ExamPointDetail', ({ type, params }) => {
            switch (type) {
                case 'init':
                    setInitInfo({
                        ...params,
                        knowledgeSource: params.knowledgeSource ?? 0, // 考点来源 默认 0：预测分
                        sourceFromType: params.sourceFromType ?? 100534177, // 100534177 新题库id
                        hasAllRequiredParams: areKeysPresentAndNonEmpty(params, ['projectId', 'subjectId', 'examSeasonId', 'knowledgeId']),
                    });
                    break;
                default:
                    setInitInfo(undefined);
                    break;
            }
        });

        return () => {
            globalStore.unsubscribe('PredictionScore');
        };
    }, []);

    const handleGoBack = () => {
        globalStore.publish('main-app', { type: 'goBack' });
    };

    return (
        <div className="sub-tiku__exam-point-detail-page">
            <div className="sub-tiku__exam-point-detail-header">
                <div className="sub-tiku__exam-point-detail-header-content">
                    <div onClick={handleGoBack}>
                        <LeftOutlined />
                        返回
                    </div>
                    <div>考点详情</div>
                    <div></div>
                </div>
            </div>
            <div className="sub-tiku__exam-point-detail-content">
                <div>
                    <ExamPointDeFinition detailData={detailData} />
                    <ExamPointVideos initInfo={initInfo} />
                    {!!detailData.totalQuestionCount && <ExamPointPractice detailData={detailData} initInfo={initInfo} />}
                    {!!detailData.finishedQuestionCount && <ExamPointAnalysis detailData={detailData} />}
                </div>
                <div>
                    {/* <AiSuggestion /> */}
                    {detailData.showPopup === 1 && <AiEfficiency data={detailData} />}
                    <ExamPointChart initInfo={initInfo} />
                </div>
            </div>
        </div>
    );
};

export default memo(ExamPointDetail);
